export interface ILevel {
  name: string
  filename: string
}

export const levels: ILevel[] = [
  {
    name: 'Level 1',
    filename: 'a1',
  },
  {
    name: 'Level 2',
    filename: 'a2',
  },
  {
    name: 'Level 3',
    filename: 'a3',
  },
]
